/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIRootAccount
 */
export interface APIRootAccount {
    /**
     * 
     * @type {string}
     * @memberof APIRootAccount
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIRootAccount
     */
    name: string;
}

/**
 * Check if a given object implements the APIRootAccount interface.
 */
export function instanceOfAPIRootAccount(value: object): value is APIRootAccount {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIRootAccountFromJSON(json: any): APIRootAccount {
    return APIRootAccountFromJSONTyped(json, false);
}

export function APIRootAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRootAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function APIRootAccountToJSON(value?: APIRootAccount | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

